"use client"

import { useLocale, useTranslations } from "next-intl"
import Link from "next/link"

import Style from "./index.module.scss"

const NotFound = () => {
  const t = useTranslations("NotFound")
  const locale = useLocale()

  return (
    <div className={Style.container}>
      <svg width="437" height="340" viewBox="0 0 437 140" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group 1171275824">
          <ellipse
            id="Ellipse 1147"
            cx="208.5"
            cy="229.5"
            rx="208.5"
            ry="110.5"
            fill="url(#paint0_linear_3388_37119)"
          />
          <path
            id="Rectangle 34624825"
            d="M401.989 123.622C408.176 117.203 418.395 117.016 424.813 123.202C431.232 129.389 431.42 139.608 425.233 146.027L400.446 171.742C394.259 178.16 384.041 178.348 377.622 172.161C371.203 165.974 371.015 155.755 377.202 149.337L401.989 123.622Z"
            fill="url(#paint1_linear_3388_37119)"
          />
          <path
            id="Rectangle 34624826"
            d="M115.933 11.6797C122.151 5.22916 132.421 5.04039 138.871 11.258C145.322 17.4757 145.51 27.7452 139.293 34.1957L114.617 59.7952C108.4 66.2457 98.1301 66.4345 91.6796 60.2168C85.2291 53.9992 85.0403 43.7296 91.258 37.2792L115.933 11.6797Z"
            fill="url(#paint2_linear_3388_37119)"
          />
          <g id="Group 1171275823">
            <g id="404">
              <path
                id="Vector"
                d="M309.878 159.24V139.144H264.694L261.75 127.88L311.542 69H324.982V126.216H337.782V139.144H324.982V159.24H309.878ZM280.438 126.216H309.878V90.76L280.438 126.216Z"
                fill="url(#paint3_linear_3388_37119)"
              />
              <path
                id="Vector_2"
                d="M126.128 159.24V139.144H80.944L78 127.88L127.792 69H141.232V126.216H154.032V139.144H141.232V159.24H126.128ZM96.688 126.216H126.128V90.76L96.688 126.216Z"
                fill="url(#paint4_linear_3388_37119)"
              />
            </g>
            <g id="Group 1171275822">
              <circle
                id="Ellipse 1148"
                cx="213"
                cy="114"
                r="37"
                fill="url(#paint5_linear_3388_37119)"
                stroke="url(#paint6_linear_3388_37119)"
                strokeWidth="2"
              />
              <circle id="Ellipse 1152" cx="215" cy="137" r="4" fill="url(#paint7_linear_3388_37119)" />
              <path
                id="Ellipse 1149"
                d="M181.084 95.6829C168.795 92.4793 159.832 92.6262 157.632 96.8595C153.709 104.407 172.768 122.085 200.201 136.344C227.635 150.603 253.054 156.045 256.977 148.498C259.084 144.443 254.56 137.466 245.668 129.666"
                stroke="url(#paint8_linear_3388_37119)"
                strokeWidth="5"
              />
              <circle id="Ellipse 1150" cx="235" cy="115" r="6" fill="url(#paint9_linear_3388_37119)" />
              <circle id="Ellipse 1151" cx="191.5" cy="108.5" r="3.5" fill="url(#paint10_linear_3388_37119)" />
            </g>
          </g>
          <g id="Frame" clipPath="url(#clip0_3388_37119)">
            <path
              id="Vector_3"
              d="M261.184 48.9315C262.121 47.3077 263.196 46.1962 263.989 45.5718C264.783 44.9474 265.901 44.5105 267.088 44.3297C268.369 43.9865 269.462 43.9681 270.786 44.2996C271.948 44.5374 273.016 44.9375 274.152 45.5938C276.426 46.9063 277.837 48.587 278.711 50.8236C279.422 52.9663 279.297 55.0589 278.078 57.1698C277.515 58.1441 276.722 58.7685 275.928 59.3929C275.135 60.0173 273.76 60.5228 271.805 60.9095C269.85 61.2962 268.894 61.8268 268.126 62.0327C267.357 62.2386 266.82 62.7943 266.12 63.2564C265.42 63.7184 265.301 64.2993 264.364 65.9231L261.116 64.0481C262.054 62.4243 262.685 61.7061 263.316 60.988C263.947 60.2698 264.647 59.8078 265.509 59.4395C266.371 59.0713 267.327 58.5406 269.12 58.0602C270.913 57.5798 272.194 57.2367 272.8 56.937C273.406 56.6374 274.199 56.013 274.855 54.8763C275.512 53.7397 275.493 52.6465 275.15 51.3659C274.807 50.0852 273.951 48.9418 272.49 48.0981C269.242 46.2231 266.306 47.5589 264.431 50.8065L261.184 48.9315ZM260.614 72.4183L257.366 70.5433L259.241 67.2957L262.489 69.1707L260.614 72.4183Z"
              fill="#D7000F"
            />
          </g>
          <g id="Frame_2" clipPath="url(#clip1_3388_37119)">
            <path
              id="Vector_4"
              d="M235.9 42.7071C236.256 41.379 236.807 40.3877 237.25 39.7948C237.694 39.2019 238.403 38.6801 239.209 38.3268C240.051 37.8407 240.822 37.6202 241.823 37.6037C242.691 37.5516 243.524 37.6323 244.453 37.8814C246.313 38.3796 247.631 39.3023 248.675 40.7207C249.585 42.1035 249.894 43.6096 249.431 45.3362C249.217 46.1331 248.774 46.726 248.33 47.3189C247.887 47.9118 247.009 48.5307 245.697 49.1757C244.386 49.8207 243.809 50.3781 243.304 50.6697C242.799 50.9614 242.524 51.4571 242.116 51.9172C241.708 52.3773 241.734 52.8113 241.378 54.1394L238.722 53.4277C239.078 52.0995 239.388 51.4711 239.699 50.8426C240.01 50.2141 240.418 49.754 240.959 49.3295C241.499 48.905 242.076 48.3477 243.255 47.6671C244.433 46.9865 245.275 46.5004 245.648 46.1731C246.02 45.8458 246.464 45.2529 246.713 44.3232C246.962 43.3935 246.742 42.6227 246.255 41.7807C245.769 40.9387 244.946 40.2911 243.751 39.9708C241.095 39.2591 239.268 40.7626 238.557 43.4189L235.9 42.7071ZM239.955 59.452L237.298 58.7403L238.01 56.084L240.666 56.7957L239.955 59.452Z"
              fill="#D7000F"
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_3388_37119"
            x1="208.5"
            y1="37.3248"
            x2="207.274"
            y2="211.23"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D7000F" stopOpacity="0.66" />
            <stop offset="1" stopColor="#FFDDE0" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_3388_37119"
            x1="367.206"
            y1="170.662"
            x2="403.724"
            y2="103.973"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0" />
            <stop offset="1" stopColor="#EFEFF1" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_3388_37119"
            x1="81.2328"
            y1="58.6885"
            x2="117.847"
            y2="-7.97761"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0" />
            <stop offset="1" stopColor="#EFEFF1" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_3388_37119"
            x1="269.735"
            y1="81.1726"
            x2="341.515"
            y2="116.046"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#D7D7D8" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_3388_37119"
            x1="85.8354"
            y1="63.2806"
            x2="179.077"
            y2="129.11"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#D7D7D8" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_3388_37119"
            x1="190"
            y1="77"
            x2="262.975"
            y2="140.269"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#D3D3D4" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_3388_37119"
            x1="192.5"
            y1="86.5"
            x2="252.097"
            y2="132.269"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#D5D5D5" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_3388_37119"
            x1="219"
            y1="134.333"
            x2="209"
            y2="140"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#CDCDCF" />
            <stop offset="1" stopColor="#F2F2F2" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_3388_37119"
            x1="156.938"
            y1="98.1953"
            x2="252.73"
            y2="154.48"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EFEFEF" />
            <stop offset="1" stopColor="#CDCDCD" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_3388_37119"
            x1="241"
            y1="111"
            x2="226"
            y2="119.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#CDCDCF" />
            <stop offset="1" stopColor="#DEDEDF" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_3388_37119"
            x1="181"
            y1="110.5"
            x2="189.975"
            y2="103.488"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0" />
            <stop offset="1" stopColor="#E6E6E6" />
          </linearGradient>
          <clipPath id="clip0_3388_37119">
            <rect width="30" height="30" fill="white" transform="translate(261 38) rotate(30)" />
          </clipPath>
          <clipPath id="clip1_3388_37119">
            <rect width="22" height="22" fill="white" transform="translate(233.695 35) rotate(15)" />
          </clipPath>
        </defs>
      </svg>
      <p className={Style.errorTitle}>{t("title")}</p>
      <p className={Style.errorDesc}>{t("desc")}</p>

      <Link href={`/${locale}`} className={Style.backHomeBtn}>
        {t("backHome")}
      </Link>
    </div>
  )
}

export default NotFound
